inputs-file
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      input(class="form-file-control { opts.klass }" accept="{ opts.accept }" name="{ opts.name }" type="file" value="{ opts.value }" onChange="{this.onChange}")
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.file');
